<template>
  <div>
    <div class="mb-4">
      <div
        v-for="(area, key) in data.areas"
        :key="key"
        class="area-item mt-3 rounded "
      >
        <div
          class="d-flex justify-content-between shadow-sm px-3 py-1 mb-2 rounded"
          :class="{
            displayed: area.displayed,
            'border border-danger': !area.valid,
          }"
        >
          <div class="mt-1">
            <a
              data-toggle="collapse"
              :href="`#${areaItemId(key)}`"
              role="button"
              aria-expanded="false"
              aria-controls="multiCollapseExample1"
              class="area-item-collapse-button bg-white rounded-circle mr-2 "
              :class="[
                { 'fas fa-angle-down': area.displayed },
                { 'fas fa-angle-right': !area.displayed },
                { 'text-success': area.valid },
                { 'text-orange': !area.valid },
              ]"
              @click="onDisplayArea(area)"
            ></a>
            <span class="fs-16 font-weight-bold">{{ area.title }}</span>
          </div>
        </div>
        <div :id="areaItemId(key)" class="collapse multi-collapse mt-4">
          <section-title content="Tipo de Evaluación" has-line />
          <backup-document
            :key="'backup-' + key + '-' + reloadKey"
            :read-only="isReadOnly"
            :area-id="area.areaId"
            :sub-area-id="area.subAreaId"
            :studentSieIdProp="data.studentSieId"
            :transition-student-id="data.transitionStudentId"
            :objKey="key"
            @files="(data) => gettingBackupDocument(data, key, area)"
            @remove="onRemoveDocument"
          />
        </div>
      </div>
    </div>

    <div class="py-4 d-flex justify-content-end">
      <action-button
        type="button"
        text="Continuar"
        i="fas fa-arrow-alt-circle-right"
        variant="success"
        @click="next"
      />
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';
import BackupDocument from '../../profile/components/BackupDocument';
import SectionTitle from 'SectionTitle';
export default {
  name: 'AvailableEvaluations',
  components: {
    ActionButton,
    BackupDocument,
    SectionTitle,
  },
  props: {
    data: {
      type: Object,
      dafault: () => ({}),
    },
    value: {
      type: Object,
      dafault: () => ({}),
    },
    isReadOnly: {
      type: Boolean,
      dafault: () => false,
    },
  },
  data: () => ({
    backupDocumentsData: [],
    validated: false,
    removedDocuments: [],
    reloadKey: 0,
  }),
  computed: {
    areaItemId: () => (key) =>
      `transition-student-profile-area-collapse-${key}`,
  },
  watch: {
    'data.areas': {
      handler() {
        this.reloadKey++;
      },
    },
  },
  methods: {
    onRemoveDocument(documentId) {
      documentId = documentId?.toLowerCase();
      const entry = this.backupDocumentsData.find((x) =>
        x.files.some((f) => f.id?.toLowerCase() == documentId)
      );
      if (entry) {
        const file = entry.files.find((f) => f.id?.toLowerCase() == documentId);
        const index = entry.files.indexOf(file);
        const details = entry.types[index] ?? {};
        file.deleteFromServer = true;
        this.removedDocuments.push({
          file,
          details: { ...details, areaId: entry.areaId, subAreaId: entry.subAreaId },
        });
        this.$emit('removedDocuments', this.removedDocuments);
      }
    },
    onDisplayArea(area) {
      area.displayed = !area.displayed;
      this.$forceUpdate();
    },
    gettingBackupDocument(data, key, area) {
      data.areaId = area.areaId;
      data.subAreaId = area.subAreaId;
      if (this.validated) {
        area.valid = Boolean(data.files?.length);
        this.$emit('checkValidation');
      }
      this.backupDocumentsData[key] = data;
      this.value.backupDocumentsData = this.backupDocumentsData;
      this.$emit('input', this.value);
      this.$forceUpdate();
    },
    async validate() {
      const valid = this.data.areas
        .map((area, i) => {
          area.valid = Boolean(this.backupDocumentsData[i]?.files?.length);
          return area.valid;
        })
        .every((valid) => valid);
      this.validated = true;
      this.$forceUpdate();
      return {
        valid,
        message: valid
          ? ''
          : 'Al menos una en cada área y sub-área de transición',
      };
    },
    next() {
      this.$emit('next', this.value);
    },
  },
};
</script>
<style scoped lang="scss">
.area-item > div:first-child {
  background-color: #cbd6d1;
  border-radius: 0.25rem 0.25rem 0px 0px;
}
.fs-16 {
  font-size: 16px;
}
.area-item-collapse-button {
  height: 24px;
  width: 24px;
  text-align: center;
  padding-top: 2px;
  margin-bottom: 4px;
  border: 2px solid white;
  cursor: pointer;
  text-decoration: none;
}
.area-item-collapse-button.fa-check {
  padding-top: 5px !important;
}
</style>
